import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

export default ({className, color, size}) => <CircularProgress className={className} color={color} disableShrink={true} size={(size || 30)} />;
